module.exports = __webpack_public_path__ + "static/media/english.c4cd6642.svg";